import { Component, OnInit } from '@angular/core';
import { SidenavService } from './services/sidenav.service';
import { onMainContentChange } from './animations/animations';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  animations: [ onMainContentChange ]
})
export class ReportsComponent implements OnInit {
  public onSideNavChange: boolean;
  
  constructor(private _sidenavService: SidenavService) {
    this._sidenavService.sideNavState$.subscribe( res => {
    
      this.onSideNavChange = res;
    })
  }
  ngOnInit(): void {
  }

}
